import CustomInput from '../../../../components/atoms/Input';

export default function FormConfirm({ enamelPaintingForm }) {

    if (enamelPaintingForm) {
        console.log('enamelPaintingForm', enamelPaintingForm)
    }

    return (
        <div className='enamel-form-confirm-container'>
            {/* Confirm area for the technician */}
            <div className="enamel-form-confirm">
                {
                    enamelPaintingForm?.confirmData.name ?
                        <span>
                            <span className="confirming-person">{`${enamelPaintingForm?.confirmData.name}`} </span>
                            tarafından onaylandı</span> :
                        <span>Onay bilgisi bulunmamaktadır</span>
                }
            </div>
            <div className='enamel-form-confirm'>
                <div className='enamel-form-confirm-title'>
                    <h2>Parlak E.Lot:</h2>
                    <CustomInput
                        id={'shining-lot-id'}
                        name={'shiningLotNo'}
                        defaultValue={enamelPaintingForm?.shiningLotNo}
                        type={"number"}
                    />
                </div>
                <div className='enamel-form-confirm-title'>
                    <h2>Mat E.Lot:</h2>
                    <CustomInput
                        id={'work-order-form-id'}
                        name={'dullLotNo'}
                        defaultValue={enamelPaintingForm?.dullLotNo}
                        type={"number"}
                    />
                </div>
                <div className='enamel-form-confirm-title'>
                    <h2>Toplam Asılan Adet:</h2>
                    <h6>{enamelPaintingForm?.totalCount}</h6>
                </div>
            </div>
        </div>
    );
}